export default {
  dynamicAttributes: (state) => state.dynamicAttributes,
}
